interface PostcodeResponse {
    _embedded: {
        addresses: PostcodeEntry[];
    };
    _links: {
        next: {
            href: string;
        };
        self: {
            href: string;
        };
    };
    page: {
        size: number;
        totalElements: number;
        totalPages: number;
        number: number;
    };
}

interface PostcodeEntry {
    id: string,
    street: string,
    number: number,
    letter: string | null,
    addition: string | null,
    postcode: string | null,
    surface: number | null,
    nen5825: {
        street: string,
        postcode: string,
    },
    city: {
        id?: string,
        label?: string,
    },
    municipality: {
        id: string,
        label: string,
    },
    province: {
        id: string,
        label: string,
    },
    geo: {
        center: {
            wgs84: {
                type: string,
                coordinates: [number, number],
                crs: {
                    type: string,
                    properties: {
                        name: string,
                    },
                },
            },
            rd: {
                type: string,
                coordinates: [number, number],
                crs: {
                    type: string,
                    properties: {
                        name: string,
                    },
                },
            },
        },
        exterior: {
            wgs84: {
                type: string,
                coordinates: [[number, number]],
                crs: {
                    type: string,
                    properties: {
                        name: string,
                    },
                },
            },
        },
    },
    type: string,
    purpose: string,
    year: number,
}

class PostcodeAPI {
    static readonly baseUrl: string = 'https://api.postcodeapi.nu/v2';

    static readonly apiKey: string = '1ToA8FZ2eB9FZCvA53Ce79c83sMxVdtk2m7i58E2';

    static async lookup(postcode: string, number: number | string) {
        const formattedPostcode = postcode.replace(/\s/g, '').toUpperCase();

        const response = await fetch(`${this.baseUrl}/addresses?postcode=${formattedPostcode}&number=${number}`, {
            headers: { 'x-api-key': PostcodeAPI.apiKey },
        });

        if (response.status === 400) {
            throw new Error('Ongeldige postcode');
        }

        if (response.status === 401) {
            throw new Error('Ongeldige API key');
        }

        if (response.status === 403) {
            throw new Error('Geen toegang');
        }

        if (response.status === 429) {
            throw new Error('Limiet overschreden');
        }

        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { _embedded } = await response.json() as PostcodeResponse;
        const { addresses } = _embedded;

        if (addresses.length === 0) {
            throw new Error('Geen adres gevonden');
        }

        return addresses[0];
    }
}

export default PostcodeAPI;
